export const AgentStatusOptions = [
  { label: "On Call", value: "On Call" },
  { label: "Available", value: "Available" },
  { label: "On Break", value: "On Break" },
  { label: "Logged Out", value: "Logged Out" },
  { label: "Wrap Up", value: "Wrap Up" },
];

export const RoleOptions = [
  { label: "Owner", value: "owner" },
  { label: "Agent", value: "agent" },
  { label: "Supervisor", value: "supervisor" }
];

export const AgentTypeOptions = [
  { label: "Inbound", value: "INBOUND" },
  { label: "Outbound", value: "OUTBOUND" },
  { label: "Blended", value: "BLENDED" }
];
